// components
import {
  styled,
  List,
  ListProps,
  ListItem,
  ListItemProps,
  darken,
  Box,
  BoxProps
} from '@mui/material';

// types
import { FilterSteps } from './MatchDrawerTables.types';

export const StyledSettingsList = styled(List)<ListProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));

export const StyledSettingsListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'currentStep' && prop !== 'step'
})<ListItemProps & { currentStep: FilterSteps | undefined; step: FilterSteps }>(
  ({ theme, currentStep, step }) => ({
    backgroundColor:
      currentStep?.id === step.id
        ? darken(theme.palette.background.default, 0.15)
        : darken(theme.palette.background.default, 0.05),
    borderRadius: '32px',
    padding: theme.spacing(1, 4),
    transition: 'background-color 0.3s ease',

    '& span': {
      fontFamily:
        currentStep?.id === step.id
          ? 'SourceSansPro-Bold'
          : 'SourceSansPro-Regular'
    },

    '&:hover': {
      backgroundColor: darken(theme.palette.background.default, 0.1),
      transition: 'background-color 0.3s ease',
      cursor: 'pointer'
    }
  })
);

export const StyledLottieContainer = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 'calc(100% - 80px)'
}));

export const StyledLottieFrame = styled(Box)<BoxProps>(() => ({
  width: '200px',
  height: '200px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
}));
